<template>
  <div
    class="publicity"
    :style="{'background-image': 'url('+($imgPath + bgImg) +')'}"
  >
    <!-- 活动名称 -->
    <div class="name">
      {{ promotionData.name }}
    </div>
    <!-- 套餐详情 -->
    <div class="combo">
      <div class="store-name">{{ userInfo.dealerName }}</div>
      <div class="combo-info">
        <!-- 价格 -->
        <div class="price">
          <van-row type="flex">
            <van-col span="12">
              <span>原价:</span>
              <span>￥{{ totalPrice }}</span>
              <span>元</span>
            </van-col>
            <van-col span="12">
              <span v-if="promotionData.isDeposit === false">感恩价:</span>
              <span v-if="promotionData.isDeposit === true">定金:</span>
              <span>￥{{ promotionData.price }}</span>
              <span>元</span>
            </van-col>
          </van-row>
        </div>
        <div class="title">感恩大礼包详情</div>
        <div class="detail">
          <van-row type="flex" class="combo-title">
            <van-col span="6">项目</van-col>
            <van-col span="6">单价</van-col>
            <van-col span="6">数量</van-col>
            <van-col span="6">合计</van-col>
          </van-row>
          <van-row
            type="flex"
            class="combo-item"
            v-for="(item, index) in promotionData.serviceItems"
            :key="index"
          >
            <van-col span="6">{{ item.itemName }}</van-col>
            <van-col span="6">{{ item.unitPrice }}元</van-col>
            <van-col span="6">{{ item.quantity + item.unit }}</van-col>
            <van-col span="6">{{ item.unitPrice * item.quantity }}元</van-col>
          </van-row>
        </div>
      </div>
    </div>
    <!-- 活动规则 -->
    <div class="store">
      <div class="title">活动规则</div>
      <div class="detail">
        <div class="store-describe">
          {{ promotionData.rule }}
        </div>
      </div>
    </div>
    <!-- 活动倒计时 -->
    <div class="activity-countdown">
      <span>距离活动结束</span>
      <span class="day">03</span>
      <span>天</span>
      <span class="hour">18</span>
      <span>:</span>
      <span class="minute">18</span>
      <span>:</span>
      <span class="second">18</span>
    </div>
    <!-- 门店详情 -->
    <div class="store">
      <div class="title">门店详情</div>
      <div class="detail">
        <div
          class="store-img"
          v-for="(item, index) in promotionData.pics"
          :key="index"
        >
          <img :src="$imgPath + item" alt="" />
        </div>
        <div class="store-img" v-for="(item, index) in dealerPic" :key="index">
          <img :src="$imgPath + item" alt="" />
        </div>
        <div class="store-describe">{{ userInfo.dealerDescription }}</div>
      </div>
    </div>
    <!-- 购买记录 -->
    <div class="purchase-history">
      <div class="title">
        <span>已购买</span>
        <span class="purchase-total">888</span>
        <span>份</span>
      </div>
      <div class="detail">
        <van-row type="flex" class="item">
          <van-col span="12">
            <img src="@/assets/user.png" class="phone" />
            <span>12312312312</span>
          </van-col>
          <van-col span="12">12-10 15:00</van-col>
        </van-row>
        <van-row type="flex" class="item">
          <van-col span="12">
            <img src="@/assets/user.png" class="phone" />
            <span>12312312312</span>
          </van-col>
          <van-col span="12">12-10 15:00</van-col>
        </van-row>
        <van-row type="flex" class="item">
          <van-col span="12">
            <img src="@/assets/user.png" class="phone" />
            <span>12312312312</span>
          </van-col>
          <van-col span="12">12-10 15:00</van-col>
        </van-row>
      </div>
    </div>
    <!-- 推荐排行榜 -->
    <div class="store">
      <div class="title">推荐排行榜</div>
      <div class="recommend-list">
        <div class="top-three">
          <div class="two">
            <div class="img">
              <img src="@/assets/user.png" class="phone" />
              <span>2</span>
            </div>
            <div class="nikename">asdasdas</div>
            <div class="recommend-user">推荐 6人</div>
          </div>
          <div class="one">
            <div class="img">
              <img src="@/assets/user.png" class="phone" />
              <span>1</span>
            </div>
            <div class="nikename">asdasdas</div>
            <div class="recommend-user">推荐 6人</div>
          </div>
          <div class="three">
            <div class="img">
              <img src="@/assets/user.png" class="phone" />
              <span>3</span>
            </div>
            <div class="nikename">asdasdas</div>
            <div class="recommend-user">推荐 6人</div>
          </div>
        </div>
        <div class="other">
          <div class="user-info">
            <span class="sort">4</span>
            <img src="@/assets/user.png" alt="" />
            <div class="nikename">哈哈哈哈哈哈哈哈哈哈哈哈</div>
          </div>
          <div class="recommend-user">推荐6人</div>
        </div>
        <div class="other">
          <div class="user-info">
            <span class="sort">4</span>
            <img src="@/assets/user.png" alt="" />
            <div class="nikename">哈哈哈哈哈哈哈哈哈哈哈哈</div>
          </div>
          <div class="recommend-user">推荐6人</div>
        </div>
        <div class="other">
          <div class="user-info">
            <span class="sort">4</span>
            <img src="@/assets/user.png" alt="" />
            <div class="nikename">哈哈哈哈哈哈哈哈哈哈哈哈</div>
          </div>
          <div class="recommend-user">推荐6人</div>
        </div>
      </div>
    </div>
    <!-- 卡券激活时间 -->
    <div class="coupon-date">
      <div class="start">
        <span>卡券激活开始时间：</span>
        <span>{{ promotionData.activateStartTime }}</span>
      </div>
      <div class="end">
        <span>卡券激活开始时间：</span>
        <span>{{ promotionData.activateEndTime }}</span>
      </div>
      <div class="tips">请在规定时间内进行激活，超过激活时间则卡券失效。</div>
    </div>
    <!-- 抢购 -->
    <!-- <div class="suspend">
      <div class="navigation">
        <img src="@/assets/navigation.png" alt="" />
      </div>
      <a href="tel:${dealer.telephone}" class="telephone">
        <img src="@/assets/telephone.png" alt="" />
      </a>
    </div> -->
    <!-- 付款 -->
    <div class="footer">本次活动最终解释权归{{ userInfo.dealerName }}所有</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      promotionData:
        JSON.parse(localStorage.getItem("promotionData")) ||
        JSON.parse(localStorage.getItem("editData")),
      dealerPic: [],
      totalPrice: 0,
      bgImg: "",
    };
  },
  mounted() {
    this.handleDealerPic();
    this.handlePrice();
    this.bgImg = this.promotionData.bgImg;
  },
  methods: {
    // 经销商图片
    handleDealerPic() {
      // if (this.userInfo.dealerPic.length != 0) {
      //   this.dealerPic = this.userInfo.dealerPic.split(",");
      // } else {
      //   this.dealerPic = [];
      // }
    },
    // 计算原价
    handlePrice() {
      this.promotionData.serviceItems.forEach((val) => {
        this.totalPrice = this.totalPrice + val.unitPrice * val.quantity;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.publicity {
  padding: 20px;
  background-color: #fc4c27;
  background-repeat: no-repeat;
  background-size: 100%;
  box-sizing: border-box;

  .name {
    padding: 10px 20px;
    margin-top: 250px;
    margin-bottom: 20px;
    background-color: #fff100;
    border-radius: 5px;
    text-align: left;
    font-size: 20px;
    font-weight: 600;
    color: #900018;
  }

  .combo {
    margin-bottom: 20px;

    .store-name {
      width: 80%;
      margin: 0 auto;
      padding: 3px 0;
      background-color: #ff1500;
      color: #fef5e6;
      font-weight: 600;
      text-align: center;
      border-radius: 20px 20px 0 0;
    }

    .combo-info {
      padding: 10px 0;
      background-color: #fcf6e4;
      border-radius: 10px;

      .title {
        width: 60%;
        margin: 0 auto;
        margin-bottom: 10px;
        padding: 5px 0;
        background-color: #fda007;
        color: #fcf6e4;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        border-radius: 50px;
      }

      .detail {
        .combo-title {
          text-align: center;
          font-size: 18px;

          .van-col--6:nth-child(1) {
            flex: 2;
            background-color: #00a0e9;
            margin-right: 5px;
          }

          .van-col--6:nth-child(2) {
            flex: 1;
            background-color: #fe8004;
            margin-right: 5px;
          }

          .van-col--6:nth-child(3) {
            flex: 1;
            background-color: #74c455;
            margin-right: 5px;
          }

          .van-col--6:nth-child(4) {
            flex: 1;
            background-color: #24ac00;
          }
        }

        .combo-item {
          padding-top: 5px;
          text-align: center;
          font-size: 18px;

          .van-col--6:nth-child(1) {
            flex: 2;
          }

          .van-col--6:nth-child(2) {
            flex: 1;
            color: #fb4b27;
          }

          .van-col--6:nth-child(3) {
            flex: 1;
          }

          .van-col--6:nth-child(4) {
            flex: 1;
          }
        }
      }
    }
  }

  .price {
    padding: 10px;

    .van-col--12:nth-child(1) {
      color: #868686;

      span:nth-child(2) {
        font-size: 24px;
        text-decoration: line-through;
      }
    }

    .van-col--12:nth-child(2) {
      text-align: right;
      font-weight: 600;
      color: #ff1500;

      span:nth-child(2) {
        // font-size: 30px;
        font-size: 24px;
      }
    }

    .van-col--12 {
      span:nth-child(2) {
        font-weight: 600;
      }
    }
  }

  .store {
    margin-bottom: 20px;

    .title {
      width: 100px;
      margin: 0 auto;
      margin-bottom: 20px;
      padding: 5px 15px;
      border: 1px solid #f6c65f;
      color: #f6c65f;
      text-align: center;
      border-radius: 50px;
    }

    .detail {
      padding: 10px;
      background-color: #fcf6e4;
      border-radius: 10px;

      .store-img {
        img {
          width: 100%;
        }
      }

      .num {
        margin-bottom: 10px;
        text-align: center;

        span {
          color: brown;
          font-weight: 600;
        }
      }

      .user-list::after {
        content: "";
        display: block;
        clear: both;
        visibility: hidden;
      }

      .user {
        float: left;
        width: 20%;
        margin-bottom: 10px;

        .photo {
          width: 33px;
          height: 33px;
          margin: 0 auto;

          img {
            width: 100%;
          }
        }

        .nikename {
          width: 50px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .recommend-list {
      padding-top: 10px;
      background-color: #efeeee;

      .top-three {
        display: flex;

        .one,
        .two,
        .three {
          position: relative;
          width: 32%;
          padding-top: 20px;
          padding-bottom: 20px;
          background-color: #fff;
          border-radius: 5px;
          text-align: center;

          .img {
            position: relative;
            margin-bottom: 20px;
          }

          img {
            display: block;
            width: 60%;
            margin: 0 auto;
          }

          span {
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 20px;
            border-radius: 50%;
            text-align: center;
            line-height: 20px;
          }
        }

        .one,
        .two {
          margin-right: 5px;
        }

        .one {
          top: -5px;

          span {
            background-color: #ffb300;
          }
        }

        .two {
          span {
            background-color: #ffe19c;
          }
        }

        .three {
          span {
            background-color: #c6d3e2;
          }
        }
      }

      .other {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 20px;
        background-color: #fff;
        border-bottom: 3px solid #efeeee;
        font-size: 14px;

        .user-info {
          display: flex;
          align-items: center;

          .sort {
            margin-right: 10px;
          }

          img {
            width: 25px;
            margin-right: 10px;
          }

          .nikename {
            width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .activity-countdown {
    margin-bottom: 20px;
    text-align: center;
    color: #fff;

    .day,
    .hour,
    .minute,
    .second {
      display: inline-block;
      padding: 5px;
      background-color: #fff100;
      color: #fb4b27;
      font-size: 18px;
      font-weight: 600;
      line-height: 1;
    }
  }

  .purchase-history {
    padding: 10px;
    margin-bottom: 20px;
    background-color: #fcf6e4;
    border-radius: 10px;

    .title {
      text-align: center;
      margin-bottom: 10px;

      .purchase-total {
        color: #fb4b27;
      }
    }

    .detail {
      height: 200px;
      text-align: center;
      overflow: hidden;

      img {
        width: 25px;
        height: 25px;
        margin-right: 5px;
      }

      .item {
        padding: 5px 0;

        .weui-flex__item {
          display: flex;
          align-items: center;
        }

        .van-col--12 {
          display: flex;
          align-items: center;
        }

        .van-col--12:last-child {
          justify-content: flex-end;
        }
      }

      .item:nth-child(odd) {
        background-color: #fce3a7;
      }
    }
  }

  .coupon-date {
    padding: 20px 0;
    padding-left: 10px;
    color: #fff;
    text-align: left;

    .start,
    .end {
      margin-bottom: 5px;

      span:last-child {
        color: #fff;
      }
    }

    .tips {
      font-size: 12px;
    }
  }

  .suspend {
    position: fixed;
    right: 0;
    top: 50px;
    display: flex;
    flex-direction: column;

    .navigation,
    .telephone {
      width: 60px;
      height: 60px;
      margin-bottom: 30px;

      img {
        width: 100%;
      }
    }
  }

  .purchase {
    width: 80px;
    margin: 0 auto;
    margin-bottom: 20px;
    padding: 5px 20px;
    background-color: #f1bc5b;
    color: red;
    text-align: center;
    font-weight: 600;
    border-radius: 50px;
  }

  .footer {
    margin-bottom: 10px;
    color: #fff;
    font-size: 12px;
    text-align: center;
  }
}
</style>
